// frontend/src/hooks/useMetaCubeQuantiqueVisualizer.js
import { useState, useEffect } from "react";

export default function useMetaCubeQuantiqueVisualizer({
  running,
  chaos,
  glow,
  fractalDepth,
  quantumFlux,
  velocityFactor,
  turbulenceFactor, // 🔹 nouveau
  pulseIntensity,   // 🔹 nouveau
}) {
  const [framesBuffer, setFramesBuffer] = useState([]);
  const [entropyDyn, setEntropyDyn] = useState(null);

  useEffect(() => {
    if (!running) return;

    let eventSource;

    try {
      // Normalisation curseurs
      const velocity = (velocityFactor ?? 50) / 50.0; // 50% = vitesse normale
      const turbulence = (turbulenceFactor ?? 0) / 100.0;
      const pulse = (pulseIntensity ?? 0) / 100.0;

      // 🔹 Construire URL SSE avec tous les curseurs
      const url = `/api/geometry/metacube_quantique/animate/stream?steps=60&size=1.0&velocity=${velocity.toFixed(
        2
      )}&turbulence=${turbulence.toFixed(2)}&pulse=${pulse.toFixed(2)}`;

      // ✅ Connexion SSE au backend quantique
      eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.frames) {
            setFramesBuffer(data.frames);
          }

          if (data.entropyDyn !== undefined) {
            setEntropyDyn(data.entropyDyn);
          }
        } catch (err) {
          console.error("Erreur parsing SSE data:", err);
        }
      };

      eventSource.onerror = (err) => {
        console.error("Erreur EventSource SSE:", err);
        eventSource.close();
      };
    } catch (err) {
      console.error("Erreur connexion SSE:", err);
    }

    return () => {
      if (eventSource) {
        eventSource.close();
      }
    };
  }, [
    running,
    chaos,
    glow,
    fractalDepth,
    quantumFlux,
    velocityFactor,
    turbulenceFactor, // 🔹 maintenant pris en compte
    pulseIntensity,   // 🔹 maintenant pris en compte
  ]);

  return { framesBuffer, entropyDyn };
}
